import React from 'react';
import classnames from 'classnames';
import CloseBold from '@wix/da-ds/pkg/Icons/CloseBold';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { Url } from '@wix/da-url';

import s from './SearchFilterTags.scss';

export type Tag = {
  tag: string;
  url: string;
  selected: boolean;
};

export interface Props {
  tags: Tag[];
  className?: string;
}

export interface State {
  overflowItems: { [k: string]: boolean };
  tagWidths: { [k: string]: number };
}

const SearchFilterTags = ({ tags }) => {
  return (
    <div className={s['root']}>
      <div className={s['tags-row']}>
        {tags.map(item => (
          <BiLink
            key={item.tag}
            href={item.url}
            data-tag={item.tag}
            className={classnames(s['tag'], item.selected && s['tag-selected'])}
            biData={{
              evid: BiEventType.SEARCH_TAG_CLICK,
              tag_text: item.tag,
              is_selected: item.selected ? 0 : 1,
              link_url: `${Url.browseHomeLink()}${item.url}`,
            }}
          >
            {item.tag}
            {item.selected && (
              <div className={s['cross']}>
                <CloseBold />
              </div>
            )}
          </BiLink>
        ))}
      </div>
    </div>
  );
};
SearchFilterTags.displayName = 'SearchFilterTags';

export default SearchFilterTags;
